import { Component, Input, OnInit } from '@angular/core';import { Router } from '@angular/router';
import { Course, Hub } from '@shared/models';
import { LinkService } from '@shared/services/link.service';
 '../analytics.service';
@Component({
    selector: 'experience-menu',
    template: `
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu class="learnspace-theme" #menu="matMenu">
        <button mat-menu-item (click)="goToAnalytics()">
            <mat-icon class="fa-icon" fontSet="fa" fontIcon="fa-chart-column"></mat-icon>
            <span>Analytics</span>
        </button>
        <button mat-menu-item (click)="openSpace()">
            <mat-icon>folder_open</mat-icon>
            <span>Open Space</span>
        </button>
        <button mat-menu-item (click)="launchCourse()">
            <mat-icon fontSet="fa" fontIcon="fa-play"></mat-icon>
            <span>Launch</span>
        </button>
        <button mat-menu-item (click)="editCourse()">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
        </button>
    </mat-menu>
    
  `,
    styles: [
        `
        mat-menu {
            color: black;
          }
        .fa-icon {
          width: 20px;
          height: 20px;
          font-size: 20px;
        }

    `
    ]
})
export class ExperienceMenuComponent implements OnInit {
    @Input() course: Course;
    @Input() hub: Hub;
    constructor(
        private _router: Router,
        private _linkService: LinkService,
    ) {

    }
    ngOnInit(): void {
    }
    launchCourse(): void {
        this._linkService.launchCourse(this.course);
      }
      editCourse(): void {
        this._router.navigate([this.hub.urlTitle, this.course.learnspace_id, "courses", this.course.id]);
      }
      openSpace(): void {
        this._router.navigate([this.hub.urlTitle, this.course.learnspace_id]);
      }
      goToAnalytics(): void {
        this._router.navigate(["analytics", this.hub.urlTitle, this.course.learnspace_id, "courses", this.course.id], {
          queryParams: {
            'activeTab': null,
          },
          queryParamsHandling: 'merge'
        });
      }
}
